/** Default OpenLayers request-map polygon fill (field / fallback). */
export const REQUEST_MAP_DEFAULT_POLYGON_COLOR = 'rgba(39, 237, 0, 0.44)';
